import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { transformViewDate } from "utils/date-utils";

import useStyles from "./styles";

export interface IProps {
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  contentText: string;
  eventName: string;
  eventDate: string;
  horseName: string;
}

const RevertDecisionDialog = (props: IProps) => {
  const {
    onConfirm,
    onClose,
    title,
    contentText,
    eventName,
    horseName,
    eventDate
  } = props;

  const classes = useStyles();

  const handleRevert = () => {
    onClose();
    onConfirm();
  };

  return (
    <Dialog
      open={true}
      className={classes.confirmationDialog}
      onClose={onClose}
    >
      <DialogTitle>
        <span className={classes.dialogTitle}>{title}</span>
      </DialogTitle>
      <DialogContent>
        <div className={classes.dialogContentText}>{contentText}</div>
        <div className={classes.textTitle}>Horse Name</div>
        <div className={classes.text}>{horseName}</div>
        <div className={classes.textTitle}>{`${eventName} Date`}</div>
        <div className={classes.text}>
          {transformViewDate(eventDate, null, "MM/dd/yyyy")}
        </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.decisions}>
          <Button
            className={clsx(classes.button, classes.cancel)}
            onClick={onClose}
            data-test-id={"cancelButton"}
          >
            Cancel
          </Button>
          <Button
            className={clsx(classes.button, classes.undo)}
            onClick={handleRevert}
            data-test-id={"undoButton"}
          >
            UNDO
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(RevertDecisionDialog);
